import React from "react";
import { handleStatus } from "../../helperFunctions/helpers";

/*
style={{
                      verticalAlign: "middle",
                      justifyItems: "center",
                      textAlign: "center",
                    }}
                      */
function BadgeStatus({ item }) {
  const statusStyle = handleStatus(item);
  return (
    <td
      style={{
        textAlign: "center",
      }}
    >
      <span
        className={`badge ${statusStyle.class}`}
        style={{
          ...statusStyle.style,
        }}
      >
        {statusStyle.text}
      </span>
    </td>
  );
}

export default BadgeStatus;
